import axios from 'axios';
import { cpApiUrl, now, off } from '../config/SiteConfig';
import getUserData from './getUserData';

export default async () => {
	// Test: No PPP.
	// window.pppData = { discount: 0, discountPercent: 98, country: 'HK', countryName: 'INDIA' };

	if (!window.pppData) {
		const userData = await getUserData();

		// Fetch discount.
		const res = await axios({
			method: 'post',
			url: cpApiUrl,
			data: {
				do: 'pppDiscount',
				country: userData.country,
			},
		});

		window.pppData = {
			discount: res.data.discount,
			// discountPercent: Math.ceil(res.data.discount * 0.745 * (100 / 149) + 50), // 50% already off.
			// discountPercent: Math.ceil(res.data.discount * 0.89 * (100 / 149) + 40), // 40% already off.
			// discountPercent: Math.ceil(res.data.discount * 0.44 * (100 / 149) + 70), // 70% already off.
			discountPercent: Math.ceil(res.data.discount * (parseInt(now) / 100) * (100 / 149) + parseInt(off)), // off% already off.
			country: userData.country,
			countryName: userData.countryName,
		};
	}

	// Return it.
	return window.pppData;
};
